import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { getAuthProps } from "../../lib/authenticationLibrary";
import { generateRequestSignature } from "../RequestSigning";
const { Mutex } = require('async-mutex');

const mutex = new Mutex();
const IsProdMode = false;
// export const API_URL = "https://ipasapi.ipas.org.sg/api"
export const API_URL = "https://ipasapi.flyingcapetech.com/api"

const baseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers, { endpoint }) => {
        const UPLOAD_ENDPOINTS = ["uploadPDF"];

        if (!UPLOAD_ENDPOINTS.includes(endpoint)) {
            headers.set("Content-Type", "application/json");
        }

        const authData = getAuthProps();

        if (authData) {
            const token = authData.token.token;

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
        }

        return headers;
    }
});

export const defaultBaseQuery = async (args, api, extraOptions) => {
debugger
    // Get the actual request URL
    const url = typeof args === "string"
        ? args
        : args.url;

    // Build full URL using API_URL
    const fullUrl = new URL(url, API_URL);

    // Same format as your old Axios interceptor:
    // /api/Controller/Method?param=value
    const endpoint =
        fullUrl.pathname +
        fullUrl.search;

    // Generate fresh signature for EVERY request
    const {
        timestamp,
        nonce,
        signature
    } = generateRequestSignature(endpoint);

    // Add signature headers
    if (typeof args === "string") {

        args = {
            url: args,
            headers: {
                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };

    } else {

        args = {
            ...args,
            headers: {
                ...(args.headers || {}),
                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };
    }

    return baseQuery(args, api, extraOptions);
};

export const customFetchBase = async (args, api, extraOptions) => {
    const authData = getAuthProps();
    let token = null;
    if (authData)
        token = authData.token.token;

    if (!token) {
        window.location.href = '/login';
        return;
    }

    await mutex.waitForUnlock();

     // -----------------------------------------
    // Get actual request URL
    // -----------------------------------------

    const url = typeof args === "string"
        ? args
        : args.url;

    const fullUrl = new URL(url, API_URL);

    // Example:
    // /api/Controller/Method?param=value
    const endpoint =
        fullUrl.pathname +
        fullUrl.search;


    // -----------------------------------------
    // Generate fresh signature
    // -----------------------------------------

    const {
        timestamp,
        nonce,
        signature
    } = generateRequestSignature(endpoint);


    // -----------------------------------------
    // Add Authorization + Signature headers
    // -----------------------------------------

    if (typeof args === "string") {

        args = {
            url: args,
            headers: {
                Authorization: `Bearer ${token}`,
                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };

    } else {

        args = {
            ...args,

            headers: {
                ...(args.headers || {}),

                Authorization: `Bearer ${token}`,

                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };
    }

    args.headers = {
        ...args.headers,
        Authorization: `Bearer ${token}`,
    };

    let result = await baseQuery(args, api, extraOptions);

    if (result.error) {
        if (result.error.status === 401) {
            window.location.href = '/login';
        }
    }
    return result;
}